import { exec } from '../utils/exec';
import { getApiToken } from '../utils/tokenExchange';
import type {
  GetVariantChangeImpactArgs,
  GetVariantChangeImpactExecVariables,
  GetVariantChangeImpactExecResponse,
  VariantChangeImpact,
} from '@src/types/catalog';

/**
 * Fetches the impact assessment for proposed changes to a variant SKU's family/data fields.
 * Returns the number of active inventory items affected and price change information.
 * @param args - Contains token, partnerCode, sku, and proposed family/data changes
 * @returns Promise resolving to the change impact assessment
 */
export const getVariantChangeImpact = async (
  args: GetVariantChangeImpactArgs
): Promise<VariantChangeImpact> => {
  const { partnerCode, sku, family, data } = args;
  const token = await getApiToken(args.token);

  const query = `
    query variantChangeImpact(
      $sku: String!
      $partnerCode: String!
      $token: String!
      $family: JSON
      $data: JSON
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          variantChangeImpact(sku: $sku, family: $family, data: $data) {
            activeInventoryCount
            currentPrice
            newPrice
          }
        }
      }
    }
  `;

  const variables: GetVariantChangeImpactExecVariables = {
    token,
    partnerCode,
    sku,
    family,
    data,
  };

  const result = await exec<GetVariantChangeImpactExecVariables, GetVariantChangeImpactExecResponse>(
    query,
    { variables }
  );

  return result.restUser.partner.variantChangeImpact;
};
